export default "__VITE_ASSET__C1u3uwwx__"